// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-components/build/generate-icons

import { bellCircle16X16 } from '@ni/nimble-tokens/dist/icons/js';
import { IconSvg, registerIconSvg } from '../../icon-svg';

declare global {
    interface HTMLElementTagNameMap {
        'nimble-icon-bell-circle': IconBellCircle;
    }
}

/**
 * The icon component for the 'bellCircle' icon
 */
export class IconBellCircle extends IconSvg {
    public constructor() {
        super(bellCircle16X16);
    }
}

registerIconSvg('icon-bell-circle', IconBellCircle);
export const iconBellCircleTag = 'nimble-icon-bell-circle';
